/**
 * PoweredBy — Branding footer component
 */

import React from "react";
import { Space } from "antd";
import packageJSON from "../../../package.json";

const PoweredBy = () => (
  <Space direction="vertical" size={2} align="center" style={{ display: "flex" }}>
    <Space size={4} align="center">
      <span className="subtitle" style={{ fontSize: 11 }}>Powered by</span>
      <img
        src={require("../../assets/logo_black.svg").default}
        style={{ height: 16, marginTop: 4 }}
        alt="Appsinfinito"
      />
    </Space>
    <span className="description" style={{ fontSize: 10 }}>
      v{packageJSON.version}
    </span>
  </Space>
);

export default PoweredBy;